import React from 'react';
import { MDText } from 'i18n-react';

import {
	type IconComponent,
	GlitterIcon,
	LocationIcon,
	MagnifyingGlassIcon,
	PriceTagIcon,
} from '@motorway/mw-highway-code';

import BenefitCards from 'Components/StaticPages/ProductPageComponents/BenefitCards/BenefitCards';

import LocalTexts from '../DiscoverMWMove.texts.json';

const LocalT = new MDText(LocalTexts);

const BenefitIcons: IconComponent[] = [
	<GlitterIcon filled={false} />,
	<MagnifyingGlassIcon />,
	<PriceTagIcon filled={false} />,
	<LocationIcon filled={false} />,
];

export const BenefitsSection: React.FC = () => (
	<BenefitCards
		cards={LocalTexts.benefits.cards.map((benefit, index) => ({
			content: <p>{LocalT.translate(`benefits.cards.${index}.content`)}</p>,
			heading: LocalT.translate(`benefits.cards.${index}.heading`),
			icon: BenefitIcons[index],
			id: benefit.heading,
		}))}
		heading={LocalT.translate('benefits.heading')}
	/>
);
